import minBy from 'lodash.minby';
import maxBy from 'lodash.maxby';
import isEqual from 'lodash.isequal';
import { hasCustomYAxis } from './yAxisPredicates';
import useDataStore from '../../../store';
export const handleSetYAxis = (model) => {
    var _a, _b;
    const appKitChartId = model.ecModel.option.appKitChartId;
    const { option, coordinateSystem } = model;
    const id = `${option.id}`; // echart option id can also be a number
    // Cannot determine yAxis unless the coordinateSystem is cartesion2d
    if (coordinateSystem.type !== 'cartesian2d' ||
        id == null ||
        appKitChartId == null)
        return;
    const storeState = useDataStore.getState();
    const stores = storeState.chartStores;
    const store = stores[appKitChartId];
    if (!store)
        return;
    const state = store.getState();
    if (!state)
        return;
    if (hasCustomYAxis(option)) {
        const significantDigits = option.appKitSignificantDigits;
        const color = option.appKitColor;
        const yAxisTicks = coordinateSystem.getAxis('y').getTicksCoords();
        const min = (_a = minBy(yAxisTicks, 'tickValue')) === null || _a === void 0 ? void 0 : _a.tickValue;
        const max = (_b = maxBy(yAxisTicks, 'tickValue')) === null || _b === void 0 ? void 0 : _b.tickValue;
        if (min == null || max == null)
            return;
        const valuePartial = {
            color,
            significantDigits,
        };
        const newMax = { ...valuePartial, value: max };
        const newMin = { ...valuePartial, value: min };
        // set state only if something has changed
        if (!isEqual(newMax, state.yMaxes[id])) {
            state.setYMax(id, newMax);
        }
        if (!isEqual(newMin, state.yMins[id])) {
            state.setYMin(id, newMin);
        }
    }
    else {
        if (!isEqual(undefined, state.yMaxes[id]) ||
            !isEqual(undefined, state.yMins[id])) {
            store.getState().clearYAxis(id);
        }
    }
};
